import { defineNuxtPlugin } from '#app/nuxt'
import { LazyGlobalFooter, LazyGlobalHeader, LazyGlobalLogo, LazyGlobalNavigationDesktop, LazyGlobalNavigationDesktopCondensed, LazyGlobalNavigationMobile, LazyBlockAccordion, LazyBlockAccordionItem, LazyBlockCallToActionList, LazyBlockColumns, LazyBlockColumnsColumn, LazyBlockCommunitiesMap, LazyBlockCommunityList, LazyBlockCtaButton, LazyBlockEnquire, LazyBlockEnquiryForm, LazyBlockGallery, LazyBlockGenericIframe, LazyBlockHero, LazyBlockHeroSmall, LazyBlockHeroQuickLinksMenu, LazyBlockHeroQuickLinksMenuAerialGallery, LazyBlockHeroQuickLinksMenuAnchor, LazyBlockHeroQuickLinksMenuLink, LazyBlockHeroQuickLinksMenuPhotoGallery, LazyBlockHeroQuickLinksMenuVideoGallery, LazyBlockHeroSearch, LazyBlockHlpDetails, LazyBlockHlpListCurated, LazyBlockMediaImage, LazyBlockKeyFeatures, LazyBlockKeyFeaturesFeature, LazyBlockMap, LazyBlockMasterplan, LazyBlockNavigationMenuItem, LazyBlockNewsList, LazyBlockNewsListCurated, LazyBlockPlanInclusions, LazyBlockPropertyDetails, LazyBlockPropertyList, LazyBlockPropertyListCurated, LazyBlockRichText, LazyBlockSectionTitle, LazyBlockStatisticsGrid, LazyBlockStatisticsGridStatistic, LazyBlockTestimonialList, LazyBlockTestimonialListCurated, LazyBlockVideo, LazyContentTypeCommunity, LazyContentTypeHLP, LazyContentTypeHub, LazyContentTypeLandingPage, LazyContentTypeNewsArticle, LazyContentTypePage, LazyContentTypeProperty, LazyContentTypePropertySearch, LazyContentTypeState, LazyContentTypeTestimonial, LazyPageSection, LazySvgo360View, LazySvgo3d, LazySvgoAboutUs, LazySvgoAgenda, LazySvgoAmphitheatre, LazySvgoApartment, LazySvgoAr, LazySvgoArrowLeft, LazySvgoArrowRight, LazySvgoArtInstallations, LazySvgoBathroom, LazySvgoBbq, LazySvgoBeach, LazySvgoBedroom, LazySvgoBench, LazySvgoBin, LazySvgoBoat, LazySvgoBrochure, LazySvgoBus, LazySvgoCalendar, LazySvgoChecklist, LazySvgoChess, LazySvgoChevronDown, LazySvgoChevronUp, LazySvgoChildcare, LazySvgoCityCbd, LazySvgoClock, LazySvgoClose, LazySvgoCommunityGarden, LazySvgoCommunity, LazySvgoCycling, LazySvgoDogPark, LazySvgoDoubleGlazing, LazySvgoDownload, LazySvgoDrone, LazySvgoElectricity, LazySvgoEmail, LazySvgoEnergy, LazySvgoEntertainment, LazySvgoExpand, LazySvgoExperience, LazySvgoFacing, LazySvgoFilter, LazySvgoFish, LazySvgoFloorplan, LazySvgoFoodAndEntertainment, LazySvgoFoodCourt, LazySvgoFullscreen, LazySvgoGarage, LazySvgoGas, LazySvgoGrid, LazySvgoGym, LazySvgoHamburger, LazySvgoHighway, LazySvgoHomeForSale, LazySvgoHomeTheatre, LazySvgoHome, LazySvgoHospitals, LazySvgoKeys, LazySvgoLandAlt, LazySvgoLand, LazySvgoLivingRoom, LazySvgoLocation, LazySvgoLogosGrade, LazySvgoLotDepth, LazySvgoLotSize, LazySvgoLotWidth, LazySvgoMarker, LazySvgoMasterplan, LazySvgoMobilePhone, LazySvgoMore, LazySvgoMoveIn, LazySvgoNbn, LazySvgoPark, LazySvgoPenthouse, LazySvgoPhone, LazySvgoPhoto, LazySvgoPingPong, LazySvgoPlane, LazySvgoPlayAreas, LazySvgoPlay, LazySvgoPool, LazySvgoPowderRoom, LazySvgoPro9, LazySvgoQualityControl, LazySvgoRadioIndicatorChecked, LazySvgoRadioIndicator, LazySvgoRumpusRoom, LazySvgoSchool, LazySvgoScrollToTop, LazySvgoSearch, LazySvgoShopping, LazySvgoSolar, LazySvgoSpeech, LazySvgoSportsArena, LazySvgoStagePlan, LazySvgoStudyRoom, LazySvgoSupport, LazySvgoSwim, LazySvgoTownhouse, LazySvgoTrain, LazySvgoUpload, LazySvgoValuation, LazySvgoVideo, LazySvgoVirtualTour, LazySvgoWalkingAndCycle, LazySvgoWalking, LazySvgoWaterAlt, LazySvgoWater, LazySvgoWetlands, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["GlobalFooter", LazyGlobalFooter],
["GlobalHeader", LazyGlobalHeader],
["GlobalLogo", LazyGlobalLogo],
["GlobalNavigationDesktop", LazyGlobalNavigationDesktop],
["GlobalNavigationDesktopCondensed", LazyGlobalNavigationDesktopCondensed],
["GlobalNavigationMobile", LazyGlobalNavigationMobile],
["BlockAccordion", LazyBlockAccordion],
["BlockAccordionItem", LazyBlockAccordionItem],
["BlockCallToActionList", LazyBlockCallToActionList],
["BlockColumns", LazyBlockColumns],
["BlockColumnsColumn", LazyBlockColumnsColumn],
["BlockCommunitiesMap", LazyBlockCommunitiesMap],
["BlockCommunityList", LazyBlockCommunityList],
["BlockCtaButton", LazyBlockCtaButton],
["BlockEnquire", LazyBlockEnquire],
["BlockEnquiryForm", LazyBlockEnquiryForm],
["BlockGallery", LazyBlockGallery],
["BlockGenericIframe", LazyBlockGenericIframe],
["BlockHero", LazyBlockHero],
["BlockHeroSmall", LazyBlockHeroSmall],
["BlockHeroQuickLinksMenu", LazyBlockHeroQuickLinksMenu],
["BlockHeroQuickLinksMenuAerialGallery", LazyBlockHeroQuickLinksMenuAerialGallery],
["BlockHeroQuickLinksMenuAnchor", LazyBlockHeroQuickLinksMenuAnchor],
["BlockHeroQuickLinksMenuLink", LazyBlockHeroQuickLinksMenuLink],
["BlockHeroQuickLinksMenuPhotoGallery", LazyBlockHeroQuickLinksMenuPhotoGallery],
["BlockHeroQuickLinksMenuVideoGallery", LazyBlockHeroQuickLinksMenuVideoGallery],
["BlockHeroSearch", LazyBlockHeroSearch],
["BlockHlpDetails", LazyBlockHlpDetails],
["BlockHlpListCurated", LazyBlockHlpListCurated],
["BlockMediaImage", LazyBlockMediaImage],
["BlockKeyFeatures", LazyBlockKeyFeatures],
["BlockKeyFeaturesFeature", LazyBlockKeyFeaturesFeature],
["BlockMap", LazyBlockMap],
["BlockMasterplan", LazyBlockMasterplan],
["BlockNavigationMenuItem", LazyBlockNavigationMenuItem],
["BlockNewsList", LazyBlockNewsList],
["BlockNewsListCurated", LazyBlockNewsListCurated],
["BlockPlanInclusions", LazyBlockPlanInclusions],
["BlockPropertyDetails", LazyBlockPropertyDetails],
["BlockPropertyList", LazyBlockPropertyList],
["BlockPropertyListCurated", LazyBlockPropertyListCurated],
["BlockRichText", LazyBlockRichText],
["BlockSectionTitle", LazyBlockSectionTitle],
["BlockStatisticsGrid", LazyBlockStatisticsGrid],
["BlockStatisticsGridStatistic", LazyBlockStatisticsGridStatistic],
["BlockTestimonialList", LazyBlockTestimonialList],
["BlockTestimonialListCurated", LazyBlockTestimonialListCurated],
["BlockVideo", LazyBlockVideo],
["ContentTypeCommunity", LazyContentTypeCommunity],
["ContentTypeHLP", LazyContentTypeHLP],
["ContentTypeHub", LazyContentTypeHub],
["ContentTypeLandingPage", LazyContentTypeLandingPage],
["ContentTypeNewsArticle", LazyContentTypeNewsArticle],
["ContentTypePage", LazyContentTypePage],
["ContentTypeProperty", LazyContentTypeProperty],
["ContentTypePropertySearch", LazyContentTypePropertySearch],
["ContentTypeState", LazyContentTypeState],
["ContentTypeTestimonial", LazyContentTypeTestimonial],
["PageSection", LazyPageSection],
["Svgo360View", LazySvgo360View],
["Svgo3d", LazySvgo3d],
["SvgoAboutUs", LazySvgoAboutUs],
["SvgoAgenda", LazySvgoAgenda],
["SvgoAmphitheatre", LazySvgoAmphitheatre],
["SvgoApartment", LazySvgoApartment],
["SvgoAr", LazySvgoAr],
["SvgoArrowLeft", LazySvgoArrowLeft],
["SvgoArrowRight", LazySvgoArrowRight],
["SvgoArtInstallations", LazySvgoArtInstallations],
["SvgoBathroom", LazySvgoBathroom],
["SvgoBbq", LazySvgoBbq],
["SvgoBeach", LazySvgoBeach],
["SvgoBedroom", LazySvgoBedroom],
["SvgoBench", LazySvgoBench],
["SvgoBin", LazySvgoBin],
["SvgoBoat", LazySvgoBoat],
["SvgoBrochure", LazySvgoBrochure],
["SvgoBus", LazySvgoBus],
["SvgoCalendar", LazySvgoCalendar],
["SvgoChecklist", LazySvgoChecklist],
["SvgoChess", LazySvgoChess],
["SvgoChevronDown", LazySvgoChevronDown],
["SvgoChevronUp", LazySvgoChevronUp],
["SvgoChildcare", LazySvgoChildcare],
["SvgoCityCbd", LazySvgoCityCbd],
["SvgoClock", LazySvgoClock],
["SvgoClose", LazySvgoClose],
["SvgoCommunityGarden", LazySvgoCommunityGarden],
["SvgoCommunity", LazySvgoCommunity],
["SvgoCycling", LazySvgoCycling],
["SvgoDogPark", LazySvgoDogPark],
["SvgoDoubleGlazing", LazySvgoDoubleGlazing],
["SvgoDownload", LazySvgoDownload],
["SvgoDrone", LazySvgoDrone],
["SvgoElectricity", LazySvgoElectricity],
["SvgoEmail", LazySvgoEmail],
["SvgoEnergy", LazySvgoEnergy],
["SvgoEntertainment", LazySvgoEntertainment],
["SvgoExpand", LazySvgoExpand],
["SvgoExperience", LazySvgoExperience],
["SvgoFacing", LazySvgoFacing],
["SvgoFilter", LazySvgoFilter],
["SvgoFish", LazySvgoFish],
["SvgoFloorplan", LazySvgoFloorplan],
["SvgoFoodAndEntertainment", LazySvgoFoodAndEntertainment],
["SvgoFoodCourt", LazySvgoFoodCourt],
["SvgoFullscreen", LazySvgoFullscreen],
["SvgoGarage", LazySvgoGarage],
["SvgoGas", LazySvgoGas],
["SvgoGrid", LazySvgoGrid],
["SvgoGym", LazySvgoGym],
["SvgoHamburger", LazySvgoHamburger],
["SvgoHighway", LazySvgoHighway],
["SvgoHomeForSale", LazySvgoHomeForSale],
["SvgoHomeTheatre", LazySvgoHomeTheatre],
["SvgoHome", LazySvgoHome],
["SvgoHospitals", LazySvgoHospitals],
["SvgoKeys", LazySvgoKeys],
["SvgoLandAlt", LazySvgoLandAlt],
["SvgoLand", LazySvgoLand],
["SvgoLivingRoom", LazySvgoLivingRoom],
["SvgoLocation", LazySvgoLocation],
["SvgoLogosGrade", LazySvgoLogosGrade],
["SvgoLotDepth", LazySvgoLotDepth],
["SvgoLotSize", LazySvgoLotSize],
["SvgoLotWidth", LazySvgoLotWidth],
["SvgoMarker", LazySvgoMarker],
["SvgoMasterplan", LazySvgoMasterplan],
["SvgoMobilePhone", LazySvgoMobilePhone],
["SvgoMore", LazySvgoMore],
["SvgoMoveIn", LazySvgoMoveIn],
["SvgoNbn", LazySvgoNbn],
["SvgoPark", LazySvgoPark],
["SvgoPenthouse", LazySvgoPenthouse],
["SvgoPhone", LazySvgoPhone],
["SvgoPhoto", LazySvgoPhoto],
["SvgoPingPong", LazySvgoPingPong],
["SvgoPlane", LazySvgoPlane],
["SvgoPlayAreas", LazySvgoPlayAreas],
["SvgoPlay", LazySvgoPlay],
["SvgoPool", LazySvgoPool],
["SvgoPowderRoom", LazySvgoPowderRoom],
["SvgoPro9", LazySvgoPro9],
["SvgoQualityControl", LazySvgoQualityControl],
["SvgoRadioIndicatorChecked", LazySvgoRadioIndicatorChecked],
["SvgoRadioIndicator", LazySvgoRadioIndicator],
["SvgoRumpusRoom", LazySvgoRumpusRoom],
["SvgoSchool", LazySvgoSchool],
["SvgoScrollToTop", LazySvgoScrollToTop],
["SvgoSearch", LazySvgoSearch],
["SvgoShopping", LazySvgoShopping],
["SvgoSolar", LazySvgoSolar],
["SvgoSpeech", LazySvgoSpeech],
["SvgoSportsArena", LazySvgoSportsArena],
["SvgoStagePlan", LazySvgoStagePlan],
["SvgoStudyRoom", LazySvgoStudyRoom],
["SvgoSupport", LazySvgoSupport],
["SvgoSwim", LazySvgoSwim],
["SvgoTownhouse", LazySvgoTownhouse],
["SvgoTrain", LazySvgoTrain],
["SvgoUpload", LazySvgoUpload],
["SvgoValuation", LazySvgoValuation],
["SvgoVideo", LazySvgoVideo],
["SvgoVirtualTour", LazySvgoVirtualTour],
["SvgoWalkingAndCycle", LazySvgoWalkingAndCycle],
["SvgoWalking", LazySvgoWalking],
["SvgoWaterAlt", LazySvgoWaterAlt],
["SvgoWater", LazySvgoWater],
["SvgoWetlands", LazySvgoWetlands],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
